import { render, staticRenderFns } from "./IconPhoneOutgoingOutline.vue?vue&type=template&id=a59452dc"
import script from "./IconPhoneOutgoingOutline.vue?vue&type=script&lang=js"
export * from "./IconPhoneOutgoingOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports